import './reaction-lists.scss';
import api from 'api';
import moment from 'moment';
import { ReactionListsType, WordBinGroupType } from 'types';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router'
import NewReactionListModal from './new-reaction-list-modal';
import NewGroupNameModal from "./new-group-name-modal";
import SelectWordBin from "./select-word-bin-modal";

function ReactionLists() {
    const params: any = useParams();
    const history = useHistory();
    const [reactionLists, setReactionLists] = useState<ReactionListsType[]>([]);
    const [wordBinGroups, setWordBinGroups] = useState<WordBinGroupType[]>([]);
    const [newReactionListModalOpen, setNewReactionListModalOpen] = useState<boolean>(false);
    const [showNewGroupName,setShowNewGroupName]=useState<boolean>(false);
    const [showSelectWordBin,setShowWordBin]=useState<boolean>(false);
    const [wordBinGroup, setWordBinGroup]=useState<number>(0);
    const [wordBins,setWordBins]=useState<any[]>([]);
    const [groupId,setGroupId]=useState<number>(0);

    const NewGroupActive={
        opacity: 0.6,
        backgroundColor: 808080
    }

    const NewGroupInActive={
        opacity: 1
    }

    function onlyUnique(value:any, index:any, self:any) {
        return self.indexOf(value) === index;
    }

    const getReactionLists = useCallback(async () => {
        const data = await api.reactionLists.getAll(params.clientId);

       // @ts-ignore
        data.forEach(item=>{
                // @ts-ignore
            data.forEach(inner=>{
                        if(item.Id === inner.Id && data.indexOf(item)!==data.indexOf(inner)){
                            data.splice(data.indexOf(inner),1);
                        }
                    }
                )
           }
        )
        let count=-1;

        if(groupId>0){
            // @ts-ignore
            data.forEach(item=>{
                count++;
                if(item.WordBinGroupId!==groupId){
                    data.splice(count,1);
                }
            })
        }
        setReactionLists(data.filter((x: ReactionListsType) =>
            x.WordBinTypeId === 1
        ));
    }, [params.clientId, groupId])

    const getWordBinGroups = useCallback(async () => {
        const data = await api.reactionLists.getWordBinGroups(params.clientId);
        setWordBinGroups(data);
    }, [params.clientId])

    const goToReactionList = (reactionListId: number) => {
        history.push(`/client/${params.clientId}/project/${params.projectId}/reaction-list/wordbin/` + reactionListId);
    }

    const wordBinGroupRemove=(id:number)=>{
        api.reactionLists.deleteGroup(id).then(()=>getWordBinGroups()) ;
    }

    const addWordBin=(id:number)=>{
        setWordBinGroup(id);
        api.reactionLists.getAll(params.clientId).then(setWordBins).then(()=>setShowWordBin(true));
    }

    const openNewGroupName=()=>{
        setShowNewGroupName(true);
    }

    const loadGroup=(groupId: number) => {
        setGroupId(groupId);
        getReactionLists();
    }

    const groupClick=()=>{
        setGroupId(0);
        getReactionLists();
        getWordBinGroups();
    }

    useEffect(() => {
        getReactionLists();
        getWordBinGroups();
    }, [getReactionLists, getWordBinGroups]);

    return (
        <>
            <div className="reaction-list">
                <p>Word Lists
                    <span id="group-name"></span>
                    <i
                        className="far fa-plus"
                        onClick={() => setNewReactionListModalOpen(true)}>
                    </i>
                </p>

                <div className="flex-container" style={showNewGroupName || showSelectWordBin? (NewGroupActive):(NewGroupInActive)}>
                    <div id="groups">
                        <p>
                            <i onClick={groupClick} className="fal fa-folders"></i>
                            <span onClick={groupClick}>Groups</span>
                            <i className="fal fa-plus" onClick={openNewGroupName}></i>
                        </p>
                        <ul id="group-list">
                            {!wordBinGroups.length ? (
                                <></>
                            ) : (
                                wordBinGroups.map((x, i) => (
                                    <>
                                        {!x.IsDeleted?
                                            (<li key={i}><i onClick={()=>loadGroup(x.Id)} className="fal fa-folder"></i> <span onClick={()=>loadGroup(x.Id)}>{x.Description}</span> <i onClick={()=>addWordBin(x.Id)} className="far fa-plus"></i><i onClick={()=>wordBinGroupRemove(x.Id)} className="far fa-trash"></i></li>)
                                            :(<></>)
                                        }
                                    </>

                                ))
                            )}
                        </ul>
                    </div>

                    <div id="table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="text-bold">Name</th>
                                    <th className="text-bold">Type</th>
                                    <th className="text-center text-bold">Interval</th>
                                    <th className="text-bold">Start Date</th>
                                    <th className="text-bold">End Date</th>
                                    <th className="text-bold">Last Sent</th>
                                    <th className="text-center text-bold">Keywords</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody id="list">
                                {!reactionLists.length ? (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            <i>No word bins created.
                                            </i>
                                        </td>
                                    </tr>
                                ) : (
                                    reactionLists.filter(x => x.ProjectId === parseInt(params.projectId)).map((x, i) => (
                                        <tr onClick={() => goToReactionList(x.Id)} key={i}>
                                            <td>{x.Description}</td>
                                            <td><span>Word Bin</span></td>
                                            <td className="text-center">{x.NotificationInterval}</td>
                                            <td>{moment(x.StartDate).format("DD MMM YYYY")}</td>
                                            <td>{moment(x.StopDate).format("DD MMM YYYY")}</td>
                                            <td>{moment(x.DateLastSent).format("DD MMM YYYY HH:mm")}</td>
                                            {x.Keywords? (<td className="text-center">{x.Keywords.length}</td>):(<td className="text-center">{0}</td>)}
                                            <td><i className="fal fa-pencil"></i></td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <NewReactionListModal onSave={getReactionLists} open={newReactionListModalOpen} setOpen={setNewReactionListModalOpen} />
            {showNewGroupName && <NewGroupNameModal setShowGroupName={setShowNewGroupName} setWordBinGroups={getWordBinGroups} clientId={params.clientId}/>}
            {showSelectWordBin && <SelectWordBin setShowWordBin={setShowWordBin} selectedWordBins={wordBins} selectedWordBinGroup={wordBinGroup}></SelectWordBin>}
        </>
    )
}

export default ReactionLists;